import { Component, computed, inject, input, model, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzTableModule, NzTableQueryParams } from 'ng-zorro-antd/table';
import { ColumnType, ITableColumn, ITablePagination } from './table.types';
import { RouterModule } from '@angular/router';
import { NzFormModule } from 'ng-zorro-antd/form';
import { DatePipe, NgTemplateOutlet } from '@angular/common';
import { ViewportService } from '../../services/mobile.service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  imports: [
    TranslatePipe, 
    NzTableModule, 
    NzEmptyModule, 
    RouterModule, 
    NzFormModule, 
    NgTemplateOutlet,
    DatePipe
  ]
})
export class TableComponent {
  public viewPortService = inject(ViewportService);
  public ColumnType = ColumnType;
  public fixedColumn = false;
  expandSet = new Set<any>();

  public tableTitle = input<string>('');
  public tableColumns = input.required<ITableColumn[]>();
  public tableData = input.required<any[]>();
  public tablePagination = input<ITablePagination | null>();
  public isFrontPagination = input<boolean>(false);

  public isMobile = computed<boolean>(() => this.viewPortService.isMobile());
  public allChecked = model(false);

  public queryParamsTable = output<NzTableQueryParams>();
  public checkAllRows = output<boolean>();
  public checkRow = output<{row: any, event: boolean}>();
  public genericEvent = output<GenericEventData>();

  public onQueryParamsChange(event: NzTableQueryParams) {
    this.queryParamsTable.emit(event);
  }

  public onCheckAllChange(event: boolean) {
    this.checkAllRows.emit(event);
  }

  public onCheckRowChange(row: any, event: boolean) {
    this.checkRow.emit({row: row, event: event});
  }

  onExpandChange(id: any, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }

  hasExpandColumn(){
    return this.tableColumns().find(x => x.header.type === ColumnType.EXPAND) != undefined;
  }

  getExpandColumn() {
    return this.tableColumns().find(x => x.header.type === ColumnType.EXPAND);
  }
}

export interface GenericEventData {
  event: string;
  data: any;
}